import type { CartItem, User } from '../types';
import { fromISO, formatDateShort } from '../utils/dates';

interface CartPanelProps {
  items: CartItem[];
  users: User[];
  onRemove: (tempId: string) => void;
  onSubmit: () => void;
  submitting: boolean;
}

export function CartPanel({ items, users, onRemove, onSubmit, submitting }: CartPanelProps) {
  if (items.length === 0) {
    return (
      <div className="cart-card">
        <div className="cart-card-title">Meine Auswahl</div>
        <div style={{ fontSize: '0.813rem', color: 'var(--text-muted)', textAlign: 'center', padding: '1rem 0' }}>
          Noch keine Gerichte ausgewählt
        </div>
      </div>
    );
  }

  const userMap = new Map(users.map((u) => [u.id, u]));

  const getRecipientLabel = (item: CartItem): string => {
    if (item.recipientType === 'self') return '';
    if (item.recipientType === 'colleague') {
      const u = userMap.get(item.colleagueId || '');
      return u ? `Für Kolleg:in: ${u.firstName} ${u.lastName}` : 'Für Kolleg:in';
    }
    return `Gast: ${item.recipientName || ''}`;
  };

  return (
    <div className="cart-card">
      <div className="cart-card-title">Meine Auswahl</div>

      <div className="cart-card-items">
        {items.map((item, idx) => {
          const recipientLabel = getRecipientLabel(item);
          return (
            <div key={item.tempId} className="cart-card-item">
              {idx > 0 && <div className="cart-card-divider" />}
              <div className="cart-card-item-inner">
                <div className="cart-card-item-left">
                  <div className="cart-card-item-title">
                    {formatDateShort(fromISO(item.dateISO))} · {item.dish.name}
                  </div>
                  {recipientLabel && (
                    <div className="cart-card-item-sub">{recipientLabel}</div>
                  )}
                </div>
                <button
                  className="cart-card-remove"
                  onClick={() => onRemove(item.tempId)}
                >
                  Entfernen
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="cart-card-footer">
        <button
          className="btn btn-primary btn-lg"
          style={{ minWidth: '14rem' }}
          onClick={onSubmit}
          disabled={submitting}
        >
          {submitting ? 'Wird bestellt…' : 'Bestellung abschicken'}
        </button>
      </div>
    </div>
  );
}
